module.exports = __webpack_public_path__ + "img/card.63686434.svg";